import {
  D
} from "./chunk.NBIYIO67.js";

// node_modules/lit-html/directives/if-defined.js
var to = (t) => t ?? D;

export {
  to
};
/*! Bundled license information:

lit-html/directives/if-defined.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
